
import React from 'react';
import './Table.scss'
const Table = () => {
    return (
        <div className="table-statist">
            <div className="categories-sec">
                <h3>
                    Arxiv
                </h3>
                <div className="bg-text">
                    Arxiv
                </div>
              <div className="tables">
              <table className="mt-5" >
                    <thead>
                        <tr className="row">
                            <th className="col">Kurs</th>
                            <th className="col">Boshlangan vaqt*</th>
                            <th className="col">Tugatilgan vaqt</th>
                            <th className="col">To'plangan ball</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="row">
                            <td className="col">
                                <select>
                                    <option>Malaka oshirish</option>
                                    <option>Malaka oshirish</option>
                                </select>
                            </td>
                            <td className="col">10.02.2020</td>
                            <td className="col">10.02.2020</td>
                            <td className="col">76%</td>
                        </tr>
                    </tbody>
                </table>

                <table className="mt-5 ">
                    <thead>
                        <tr className='row'>
                            <th className="col">Modullar</th>
                            <th className="col">Boshlangan vaqt*</th>
                            <th className="col">Tugatilgan vaqt</th>
                            <th className="col">To'plangan ball</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="row">
                            <td className="col">
                                <span>1</span>-modul
                            </td>
                            <td className="col">10.02.2020</td>
                            <td className="col">10.02.2020</td>
                            <td className="col">76%</td>
                        </tr>
                        <tr className="row">
                            <td className="col">
                                <span>1</span>-modul
                            </td>
                            <td className="col">10.02.2020</td>
                            <td className="col">10.02.2020</td>
                            <td className="col">76%</td>
                        </tr>
                        <tr className="row">
                            <td className="col">
                                <span>1</span>-modul
                            </td>
                            <td className="col">10.02.2020</td>
                            <td className="col">10.02.2020</td>
                            <td className="col">76%</td>
                        </tr>
                        <tr className="row">
                            <td className="col">
                                <span>1</span>-modul
                            </td>
                            <td className="col">10.02.2020</td>
                            <td className="col">10.02.2020</td>
                            <td className="col">76%</td>
                        </tr>
                        <tr className="row">
                            <td className="col">
                                <span>1</span>-modul
                            </td>
                            <td className="col">10.02.2020</td>
                            <td className="col">10.02.2020</td>
                            <td className="col">76%</td>
                        </tr>
                    </tbody>
                </table>

              </div>
            </div>
        </div>
    );
}

export default Table;
